document.addEventListener('DOMContentLoaded', function () {
  // Desktop tabs functionality
  const tabs = document.querySelectorAll('.category-tab');
  const contents = document.querySelectorAll('.content-item');

  // Initialize first active content with fade-in
  const firstActiveContent = document.querySelector('.content-item.active');
  if (firstActiveContent) {
    const firstText = firstActiveContent.querySelector('.content-text');
    if (firstText) {
      firstText.classList.add('fade-in');
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      const category = this.getAttribute('data-category');

      // Remove active class from all tabs and contents
      tabs.forEach((t) => t.classList.remove('active'));
      contents.forEach((c) => {
        c.classList.remove('active');
        // Remove fade-in class from all content texts
        const text = c.querySelector('.content-text');
        if (text) {
          text.classList.remove('fade-in');
        }
      });

      // Add active class to clicked tab
      this.classList.add('active');

      // Show corresponding content with fade animation
      const targetContent = document.querySelector(
        `[data-content="${category}"]`
      );
      if (targetContent) {
        targetContent.classList.add('active');
        const newText = targetContent.querySelector('.content-text');
        if (newText) {
          // Force reflow to ensure the opacity 0 is applied before adding fade-in
          newText.offsetHeight;
          newText.classList.add('fade-in');
        }
      }
    });
  });

  // Mobile collapsible functionality
  const collapsibleHeaders = document.querySelectorAll('.collapsible-header');

  collapsibleHeaders.forEach((header) => {
    header.addEventListener('click', function () {
      const targetId = this.getAttribute('data-target');
      const targetContent = document.getElementById(targetId);
      const icon = this.querySelector('.collapsible-icon');
      const isActive = targetContent.classList.contains('active');

      // Close all items first (accordion behavior)
      document.querySelectorAll('.collapsible-content').forEach((content) => {
        content.classList.remove('active');
        content.style.maxHeight = null;
      });
      document.querySelectorAll('.collapsible-header').forEach((h) => {
        h.classList.remove('active');
        // Reset all icons to chevron-down
        const headerIcon = h.querySelector('.collapsible-icon');
        headerIcon.innerHTML = '<path d="m6 9 6 6 6-6"/>';
        headerIcon.classList.remove('lucide-chevron-up');
        headerIcon.classList.add('lucide-chevron-down');
      });

      // If this item wasn't active, open it
      if (!isActive) {
        targetContent.classList.add('active');
        targetContent.style.maxHeight = targetContent.scrollHeight + 'px';
        this.classList.add('active');
        // Change icon to chevron-up
        icon.innerHTML = '<path d="m18 15-6-6-6 6"/>';
        icon.classList.remove('lucide-chevron-down');
        icon.classList.add('lucide-chevron-up');
      }
    });
  });
});
